import React, { useState, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useServices } from '../context/ServiceContext';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Leads.css';

/* ── Data ──────────────────────────────────────────────────── */
const SOURCES = ['All', 'Meta Ads', 'Website', 'Referral', 'Google Ads', 'BNI', 'LinkedIn', 'Instagram', 'Cold Call', 'Cold Email', 'Event', 'Other'];
const MEMBERS = ['Lakshmi', 'Arjun', 'Meera', 'Kiran'];
const COLUMNS = [
  { id: 'new',       label: 'New',       color: '#22C55E' },
  { id: 'contacted', label: 'Contacted', color: '#3B82F6' },
  { id: 'warm',      label: 'Warm',      color: '#60A5FA' },
  { id: 'hot',       label: 'Hot',       color: '#F5A623' },
  { id: 'closed',    label: 'Closed',    color: '#22C55E' },
  { id: 'lost',      label: 'Lost',      color: '#EF4444' },
];

const INIT = [
  { id:1, name:'Anand Kumar',   company:'Techwave Solutions', phone:'+91 98765 43210', email:'anand@techwave.in',      source:'Meta Ads',   status:'hot',       assigned:'Lakshmi', followUp:'2026-05-24', value:45000,  notes:'Demo done. Very interested in full suite.' },
  { id:2, name:'Priya Sharma',  company:'Bloom Studio',       phone:'+91 87654 32109', email:'priya@bloomstudio.in',   source:'Website',    status:'new',       assigned:'Arjun',   followUp:'2026-05-29', value:18000,  notes:'Filled contact form. Needs intro call.' },
  { id:3, name:'Rajesh Nair',   company:'Nair Exports',       phone:'+91 76543 21098', email:'rajesh@nairexports.com', source:'Referral',   status:'warm',      assigned:'Meera',   followUp:'2026-05-30', value:72000,  notes:'Referred by Suresh. Budget approved internally.' },
  { id:4, name:'Meera Pillai',  company:'Pillai & Co',        phone:'+91 65432 10987', email:'meera@pillaiandco.in',   source:'Meta Ads',   status:'new',       assigned:'Kiran',   followUp:'2026-05-31', value:25000,  notes:'' },
  { id:5, name:'Suresh Menon',  company:'Menon Traders',      phone:'+91 54321 09876', email:'suresh@menontraders.com',source:'Cold Call',  status:'contacted', assigned:'Lakshmi', followUp:'2026-06-01', value:35000,  notes:'Called twice. Interested but needs more time.' },
  { id:6, name:'Kavitha Rao',   company:'Rao Infra',          phone:'+91 43210 98765', email:'kavitha@raoinfra.in',    source:'Google Ads', status:'closed',    assigned:'Arjun',   followUp:'',           value:120000, notes:'Deal closed. Onboarding in progress.' },
  { id:7, name:'Deepak Singh',  company:'Singh Logistics',    phone:'+91 32109 87654', email:'deepak@singhlogistics.com',source:'Referral', status:'hot',       assigned:'Meera',   followUp:'2026-05-28', value:88000,  notes:'Very interested. Waiting on proposal.' },
  { id:8, name:'Pooja Iyer',    company:'Iyer Digital',       phone:'+91 21098 76543', email:'pooja@iyerdigital.in',   source:'Website',    status:'lost',      assigned:'Kiran',   followUp:'',           value:15000,  notes:'Went with competitor. Price sensitive.' },
  { id:9, name:'Vikram Nanda',  company:'Nanda Auto',         phone:'+91 90001 11234', email:'vikram@nandaauto.in',    source:'Meta Ads',   status:'contacted', assigned:'Lakshmi', followUp:'2026-06-03', value:52000,  notes:'Seen the ad. Booked a callback.' },
  { id:10,name:'Sreelatha K',   company:'Sreelatha Silks',    phone:'+91 80001 22345', email:'sreelatha@silks.in',     source:'Referral',   status:'warm',      assigned:'Arjun',   followUp:'2026-05-30', value:31000,  notes:'Warm lead. Asked for product catalogue.' },
];

/* ── Helpers ───────────────────────────────────────────────── */
const today = new Date().toISOString().split('T')[0];
const isOverdue = (d) => d && d < today;
const initials = (n) => n.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase();
const fmtValue = (v) => v >= 100000 ? '₹' + (v/100000).toFixed(1) + 'L' : '₹' + (v/1000).toFixed(0) + 'K';
const fmtDate  = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'numeric', month:'short' }) : '—';

/* ── Icons ─────────────────────────────────────────────────── */
const KanbanIcon = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="3" width="5" height="12" rx="1"/><rect x="17" y="3" width="5" height="15" rx="1"/></svg>;
const ListIcon   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><circle cx="3" cy="6" r="1.5" fill="currentColor"/><circle cx="3" cy="12" r="1.5" fill="currentColor"/><circle cx="3" cy="18" r="1.5" fill="currentColor"/></svg>;
const PlusIcon   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const PhoneIcon  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.46a16 16 0 0 0 6.29 6.29l1.46-1.46a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const MailIcon   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const WAIcon     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>;
const CloseIcon  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const SearchIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;

/* ── Status badge ──────────────────────────────────────────── */
function Badge({ status }) {
  const map = { new:'ld-b-green', contacted:'ld-b-blue', warm:'ld-b-sky', hot:'ld-b-gold', closed:'ld-b-green', lost:'ld-b-red' };
  return <span className={`ld-badge ${map[status] || ''}`}>{status.charAt(0).toUpperCase()+status.slice(1)}</span>;
}

/* ── Add Lead Modal ────────────────────────────────────────── */
function AddModal({ theme, onClose, onAdd }) {
  const { services } = useServices();
  const [form, setForm] = useState({ name:'', company:'', phone:'', email:'', source:'Meta Ads', status:'new', assigned:'Lakshmi', value:'', followUp:'', notes:'', location:'', service:'' });
  const set = (k,v) => setForm(f => ({ ...f, [k]:v }));
  const submit = () => {
    if (!form.name.trim()) return;
    onAdd({ ...form, id: Date.now(), value: parseInt(form.value)||0 });
    onClose();
  };
  return (
    <div className="ld-overlay" onClick={onClose}>
      <div className="ld-modal" data-theme={theme} onClick={e => e.stopPropagation()}>
        <div className="ld-modal-hd">
          <span className="ld-modal-title">Add Lead</span>
          <button className="ld-icon-btn" onClick={onClose}><CloseIcon /></button>
        </div>
        <div className="ld-modal-body">
          <div className="ld-form-row">
            <div className="ld-form-group">
              <label className="ld-lbl">Name *</label>
              <input className="ld-inp" placeholder="Full name" value={form.name} onChange={e=>set('name',e.target.value)} />
            </div>
            <div className="ld-form-group">
              <label className="ld-lbl">Company</label>
              <input className="ld-inp" placeholder="Company name" value={form.company} onChange={e=>set('company',e.target.value)} />
            </div>
          </div>
          <div className="ld-form-row">
            <div className="ld-form-group">
              <label className="ld-lbl">Phone</label>
              <input className="ld-inp" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={e=>set('phone',e.target.value)} />
            </div>
            <div className="ld-form-group">
              <label className="ld-lbl">Email</label>
              <input className="ld-inp" placeholder="email@company.com" value={form.email} onChange={e=>set('email',e.target.value)} />
            </div>
          </div>
          <div className="ld-form-row">
            <div className="ld-form-group">
              <label className="ld-lbl">Source</label>
              <select className="ld-inp ld-sel" value={form.source} onChange={e=>set('source',e.target.value)}>
                {SOURCES.filter(s=>s!=='All').map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="ld-form-group">
              <label className="ld-lbl">Status</label>
              <select className="ld-inp ld-sel" value={form.status} onChange={e=>set('status',e.target.value)}>
                {COLUMNS.map(c=><option key={c.id} value={c.id}>{c.label}</option>)}
              </select>
            </div>
          </div>
          <div className="ld-form-row">
            <div className="ld-form-group">
              <label className="ld-lbl">Assign to</label>
              <select className="ld-inp ld-sel" value={form.assigned} onChange={e=>set('assigned',e.target.value)}>
                {MEMBERS.map(m=><option key={m}>{m}</option>)}
              </select>
            </div>
            <div className="ld-form-group">
              <label className="ld-lbl">Deal value (₹)</label>
              <input className="ld-inp" placeholder="e.g. 45000" type="number" value={form.value} onChange={e=>set('value',e.target.value)} />
            </div>
          </div>
          <div className="ld-form-row">
            <div className="ld-form-group">
              <label className="ld-lbl">Location</label>
              <input className="ld-inp" placeholder="e.g. Kochi, Kerala" value={form.location} onChange={e=>set('location',e.target.value)} />
            </div>
            <div className="ld-form-group">
              <label className="ld-lbl">Service type</label>
              <select className="ld-inp ld-sel" value={form.service} onChange={e=>set('service',e.target.value)}>
                <option value="">Select service…</option>
                {services.map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <div className="ld-form-group">
            <label className="ld-lbl">Follow-up date</label>
            <input className="ld-inp" type="date" value={form.followUp} onChange={e=>set('followUp',e.target.value)} />
          </div>
          <div className="ld-form-group">
            <label className="ld-lbl">Notes</label>
            <textarea className="ld-inp ld-ta" placeholder="Any notes..." value={form.notes} onChange={e=>set('notes',e.target.value)} rows={3} />
          </div>
        </div>
        <div className="ld-modal-ft">
          <button className="ld-btn-sec" onClick={onClose}>Cancel</button>
          <button className="ld-btn-pri" onClick={submit}>Add Lead</button>
        </div>
      </div>
    </div>
  );
}

/* ── Side Panel ────────────────────────────────────────────── */
function Panel({ lead, theme, onClose, onUpdate }) {
  const [notes, setNotes] = useState(lead.notes);
  const [status, setStatus] = useState(lead.status);
  const [followUp, setFollowUp] = useState(lead.followUp);
  const save = () => onUpdate({ ...lead, notes, status, followUp });

  return (
    <div className="ld-panel-wrap">
      <div className="ld-panel-overlay" onClick={onClose} />
      <div className="ld-panel" data-theme={theme}>
        <div className="ld-panel-hd">
          <div className="ld-panel-av">{initials(lead.name)}</div>
          <div className="ld-panel-info">
            <div className="ld-panel-name">{lead.name}</div>
            <div className="ld-panel-co">{lead.company}</div>
          </div>
          <button className="ld-icon-btn" onClick={onClose}><CloseIcon /></button>
        </div>

        <div className="ld-panel-actions">
          <a href={`tel:${lead.phone}`} className="ld-act-btn"><PhoneIcon /> Call</a>
          <a href={`mailto:${lead.email}`} className="ld-act-btn"><MailIcon /> Email</a>
          <a href={`https://wa.me/${lead.phone.replace(/\D/g,'')}`} className="ld-act-btn ld-act-wa" target="_blank" rel="noreferrer"><WAIcon /> WhatsApp</a>
        </div>

        <div className="ld-panel-body">
          <div className="ld-panel-section">
            <div className="ld-panel-slbl">Contact</div>
            <div className="ld-panel-row"><PhoneIcon /><span>{lead.phone}</span></div>
            <div className="ld-panel-row"><MailIcon /><span>{lead.email}</span></div>
          </div>

          <div className="ld-panel-section">
            <div className="ld-panel-slbl">Details</div>
            <div className="ld-kv-grid">
              <span className="ld-k">Source</span><span className="ld-v">{lead.source}</span>
              <span className="ld-k">Assigned</span><span className="ld-v">{lead.assigned}</span>
              <span className="ld-k">Value</span><span className="ld-v ld-v-gold">{fmtValue(lead.value)}</span>
            </div>
          </div>

          <div className="ld-panel-section">
            <div className="ld-panel-slbl">Status</div>
            <select className="ld-inp ld-sel" value={status} onChange={e=>setStatus(e.target.value)}>
              {COLUMNS.map(c=><option key={c.id} value={c.id}>{c.label}</option>)}
            </select>
          </div>

          <div className="ld-panel-section">
            <div className="ld-panel-slbl">Follow-up date</div>
            <input className="ld-inp" type="date" value={followUp} onChange={e=>setFollowUp(e.target.value)} />
          </div>

          <div className="ld-panel-section">
            <div className="ld-panel-slbl">Notes</div>
            <textarea className="ld-inp ld-ta" rows={4} value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Add notes..." />
          </div>
        </div>

        <div className="ld-panel-ft">
          <button className="ld-btn-pri" style={{width:'100%'}} onClick={save}>Save changes</button>
        </div>
      </div>
    </div>
  );
}

/* ── Kanban Card ───────────────────────────────────────────── */
function Card({ lead, onDragStart, onClick }) {
  const overdue = isOverdue(lead.followUp);
  return (
    <div
      className={`ld-card${overdue ? ' overdue' : ''}`}
      draggable
      onDragStart={() => onDragStart(lead)}
      onClick={() => onClick(lead)}
    >
      <div className="ld-card-top">
        <div className="ld-card-av">{initials(lead.name)}</div>
        <div>
          <div className="ld-card-name">{lead.name}</div>
          <div className="ld-card-co">{lead.company}</div>
        </div>
      </div>
      <div className="ld-card-meta">
        <span className="ld-card-src">{lead.source}</span>
        <span className="ld-card-val">{fmtValue(lead.value)}</span>
      </div>
      {lead.followUp && (
        <div className={`ld-card-fu${overdue ? ' ld-fu-over' : ''}`}>
          {overdue ? '⚠ Overdue · ' : '↻ Follow-up · '}{fmtDate(lead.followUp)}
        </div>
      )}
      <div className="ld-card-assignee">{lead.assigned}</div>
    </div>
  );
}

/* ── Kanban Column ─────────────────────────────────────────── */
function Column({ col, leads, onDragStart, onDrop, onCardClick }) {
  const [over, setOver] = useState(false);
  return (
    <div
      className={`ld-col${over ? ' drag-over' : ''}`}
      onDragOver={e => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={() => { setOver(false); onDrop(col.id); }}
    >
      <div className="ld-col-hd">
        <div className="ld-col-dot" style={{ background: col.color }} />
        <span className="ld-col-label">{col.label}</span>
        <span className="ld-col-count">{leads.length}</span>
      </div>
      <div className="ld-col-body">
        {leads.map(l => (
          <Card key={l.id} lead={l} onDragStart={onDragStart} onClick={onCardClick} />
        ))}
        {leads.length === 0 && <div className="ld-col-empty">Drop here</div>}
      </div>
    </div>
  );
}

/* ── Main Component ────────────────────────────────────────── */
export default function Leads() {
  const { theme } = useTheme();
  const [leads, setLeads] = useState(INIT);
  const [view, setView] = useState('kanban');
  const [search, setSearch] = useState('');
  const [srcFilter, setSrcFilter] = useState('All');
  const [selected, setSelected] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const dragging = useRef(null);

  const filtered = leads.filter(l => {
    const matchSrc = srcFilter === 'All' || l.source === srcFilter;
    const q = search.toLowerCase();
    const matchQ = !q || l.name.toLowerCase().includes(q) || l.company.toLowerCase().includes(q) || l.source.toLowerCase().includes(q);
    return matchSrc && matchQ;
  });

  const handleDragStart = (lead) => { dragging.current = lead; };
  const handleDrop = (colId) => {
    if (!dragging.current) return;
    setLeads(ls => ls.map(l => l.id === dragging.current.id ? { ...l, status: colId } : l));
    dragging.current = null;
  };
  const handleUpdate = (updated) => {
    setLeads(ls => ls.map(l => l.id === updated.id ? updated : l));
    setSelected(updated);
  };
  const handleAdd = (lead) => setLeads(ls => [lead, ...ls]);

  const totalValue = filtered.reduce((s, l) => s + l.value, 0);
  const overdueCount = filtered.filter(l => isOverdue(l.followUp)).length;

  const TopActions = (
    <div className="ld-top-actions">
      <div className="ld-search-wrap">
        <SearchIcon />
        <input className="ld-search" placeholder="Search leads…" value={search} onChange={e=>setSearch(e.target.value)} />
      </div>
      <select className="ld-filter-sel" value={srcFilter} onChange={e=>setSrcFilter(e.target.value)}>
        {SOURCES.map(s=><option key={s}>{s}</option>)}
      </select>
      <div className="ld-view-toggle">
        <button className={`ld-vt-btn${view==='kanban'?' active':''}`} onClick={()=>setView('kanban')} title="Kanban"><KanbanIcon /></button>
        <button className={`ld-vt-btn${view==='list'?' active':''}`}   onClick={()=>setView('list')}   title="List"><ListIcon /></button>
      </div>
      <button className="ld-add-btn" onClick={()=>setShowAdd(true)}><PlusIcon /> Add Lead</button>
    </div>
  );

  return (
    <div className="ld-wrap" data-theme={theme}>
      <Sidebar />
      <div className="ld-main">
        <Topbar title="Leads" subtitle={`${filtered.length} leads · ${fmtValue(totalValue)} pipeline${overdueCount ? ` · ⚠ ${overdueCount} overdue` : ''}`} actions={TopActions} />

        {/* ── Summary strip ── */}
        <div className="ld-strip">
          {COLUMNS.map(col => {
            const count = filtered.filter(l=>l.status===col.id).length;
            const val   = filtered.filter(l=>l.status===col.id).reduce((s,l)=>s+l.value,0);
            return (
              <div key={col.id} className="ld-strip-item">
                <div className="ld-strip-dot" style={{background:col.color}} />
                <span className="ld-strip-label">{col.label}</span>
                <span className="ld-strip-count">{count}</span>
                <span className="ld-strip-val">{fmtValue(val)}</span>
              </div>
            );
          })}
        </div>

        {/* ── Kanban ── */}
        {view === 'kanban' && (
          <div className="ld-board">
            {COLUMNS.map(col => (
              <Column
                key={col.id} col={col}
                leads={filtered.filter(l=>l.status===col.id)}
                onDragStart={handleDragStart}
                onDrop={handleDrop}
                onCardClick={setSelected}
              />
            ))}
          </div>
        )}

        {/* ── List ── */}
        {view === 'list' && (
          <div className="ld-list-wrap">
            <table className="ld-table">
              <thead>
                <tr>
                  {['Name','Company','Source','Status','Assigned','Value','Follow-up'].map(h=>(
                    <th key={h} className="ld-th">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(l => (
                  <tr key={l.id} className="ld-tr" onClick={()=>setSelected(l)}>
                    <td className="ld-td">
                      <div className="ld-tr-name-wrap">
                        <div className="ld-tr-av">{initials(l.name)}</div>
                        <div>
                          <div className="ld-tr-name">{l.name}</div>
                          <div className="ld-tr-email">{l.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="ld-td ld-td-muted">{l.company}</td>
                    <td className="ld-td"><span className="ld-src-pill">{l.source}</span></td>
                    <td className="ld-td"><Badge status={l.status} /></td>
                    <td className="ld-td ld-td-muted">{l.assigned}</td>
                    <td className="ld-td ld-td-gold">{fmtValue(l.value)}</td>
                    <td className={`ld-td${isOverdue(l.followUp)?' ld-td-over':''}`}>{fmtDate(l.followUp)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {selected && <Panel lead={selected} theme={theme} onClose={()=>setSelected(null)} onUpdate={handleUpdate} />}
      {showAdd && <AddModal theme={theme} onClose={()=>setShowAdd(false)} onAdd={handleAdd} />}
    </div>
  );
}
